import Alpine from 'alpinejs'

Alpine.data('productMedia', (selected) => ({
    
    selected: selected,
    zoomed: false,
    
    isSelectedMedia(type) {
        return this.selected === type
    },
    
    selectMedia(type, emitEvent=true) {
        if(this.selected === type) {
            return
        }
        const typeBefore = this.selected
        this.selected = type
        if(!emitEvent) {
            return
        }
        this.$dispatch('product-media-selected', { 
            type: type,
            typeBefore: typeBefore
        })
    }
}))